import React from "react";
import { obterContratoPeloNumero,editarCamposContrato } from "../actions/ContratoActions";
import { adicionarItem, editarItem, deletarItem, obterItensPeloContrato } from "../actions/ItemActions";
import { cadastrarAcao } from "../actions/AcaoActions";
import { enviarEmail } from '../actions/EmailActions';
import { Modal } from 'react-bootstrap';
import { connect } from "react-redux";
import { toast } from "react-toastify";
import MapaServices from '../services/mapa';

class ContratosVincular extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contrato: {
        carregando: false,
        numero: undefined,
        data: undefined,
        preco: 0
      },
      orcamento: {
        carregando: false,
        numero: undefined,
        data: undefined,
        preco: 0
      },
      showModalVinculo: false,
      showModalDeletarItem: false,
      itemSelecionado: {},
      novosItens: [],
      btnVincular: false,
      btnDeletarItem: false
    };
  }

  async componentWillUpdate () {
    if (this.state.atualizarContrato) {
      this.setState({atualizarContrato: false});
      await this.atualizarTabelaItensContrato();
    }
  }

  validarNumero (tipo, numero) {
    let mensagem = "";
    switch (numero) {
      case numero <= 0:
        mensagem = `Não existem ${tipo} com este número!`;
        break;
      case numero === "":
        mensagem = "Você deve digitar um número maior que 0";
        break;
      default: 
        mensagem = true;
        break;
    }
    return mensagem;
  }

  async encontrarContrato () {
    this.setState({contrato: {...this.state.contrato, carregando: true}});
    let { numero } = this.state.contrato, 
      resposta = this.validarNumero("contratos", numero),
      mapavendas = new MapaServices(),
      data = {};

    if (resposta === true) {
      await this.props.obterContratoPeloNumero(numero);
      data = this.props.contrato;

      if (data === undefined) {
        toast.info("Esse contrato não existe!");
      } else {
        await this.props.obterItensPeloContrato(data.id);
        // data.itens = this.props.itens;
        if (data.numOrcamento !== null) {
          await mapavendas.getTabela(data.numOrcamento, numero).then((response) => {
            data.tabela = response;
          });
        }

        if (this.props.itens.length > 0) {
          this.calcularPreco(this.props.itens);
        }
      }

      this.setState({contrato: {...this.state.contrato, data: data, carregando: false}});

    } else {
      toast.error(resposta);
    }
  }

  async encontrarOrcamento () {
    this.setState({orcamento: {...this.state.orcamento, carregando: true}});
    let { numero } = this.state.orcamento, 
      numeroContrato = this.state.contrato.numero,
      respostaOrcamento = this.validarNumero("orçamentos", numero),
      respostaContrato = this.validarNumero("contratos", numeroContrato),
      mapavendas = new MapaServices();

    if (respostaOrcamento === true) {
      await mapavendas.getOrcamentoComKits(numero).then((response) => {
        if (response === undefined) {
          toast.info("Este orçamento não existe!");
        } else if (response.kits.length === 0) {
          toast.error("Os kits deste orçamento ainda não foram gerados!");
        } else {
          if (respostaContrato === true) {
            this.setState({orcamento: {...this.state.orcamento, data: response, carregando: false, preco: response.CustTotal.toFixed(2)}});
          } else {
            toast.error(respostaContrato);
          }
        }
      }).catch(() => {
        toast.info("Esse orçamento não existe!");
        this.setState({orcamento: {...this.state.orcamento, data: undefined, carregando: false, preco: 0}});
      });
    } else {
      toast.error(respostaOrcamento);
    }
  }

  async calcularPreco (itens) {
    let preco = 0;
    for (let i = 0; i < itens.length; i++) {
      preco += itens[i].preco * itens[i].quantidade;
    }
    this.setState({contrato: {...this.state.contrato, preco: preco.toFixed(2)}});
  }

  prepararParVincular () {
    let { orcamento } = Object.assign({}, this.state),
      itensParaAdicionar = [];
    orcamento.data.kits.forEach((item) => {
      if (this.props.itens.length > 0) {
        let itemContrato = (this.props.itens.find((kit) => { return kit.produto === item.nome && kit.observacao === item.tipo }));
        if (itemContrato === undefined) {
          itensParaAdicionar.push({...item, badge: "novo", id: undefined});
        } else if (item.qtd !== itemContrato.quantidade) {
          itensParaAdicionar.push({...item, qtd: itemContrato.quantidade, badge: item.qtd - itemContrato.quantidade, id: itemContrato.id});
        }
      } else {
        itensParaAdicionar.push({...item, badge: "novo", id: undefined});
      }
    });
    this.setState({showModalVinculo: true, novosItens: itensParaAdicionar});
  }

  async atualizarTabelaItensContrato () {
    await this.props.obterItensPeloContrato(this.state.contrato.data.id);
    if (this.props.itens.length > 0) {
      await this.calcularPreco(this.props.itens);
    }
  }

  async vincularOrcamentoAoContrato () {
    this.setState({btnVincular: true});
    let { novosItens, contrato } = this.state,
      mapavendas = new MapaServices(),
      itensPreparados = [];
    novosItens.forEach((item) => {
      let novosIds = "",
        novosNomes = "";
      if (item.itens.length > 0) {
        item.itens.forEach(itemItens => {
          if (item.tipo === "brinde") {
            novosIds = "";
            novosNomes += `${itemItens.qtd} ${itemItens.nome};`;
          } else {
            novosIds += itemItens.id + ";";
            novosNomes += `${itemItens.qtd} ${itemItens.nome};`;
          }
        });
      }
      itensPreparados.push({
        id: item.id,
        ids: novosIds === "" ? `${item.id};` : novosIds, 
        itens: novosNomes === "" ? `1 ${item.nome};` : novosNomes, 
        quantidade: item.badge === "novo" ? item.qtd : item.qtd + item.badge, 
        tipo: (item.tipo === "brinde" ? "P" : "F"), 
        contrato: contrato.data.id,
        produto: item.nome,
        preco: Number(item.preco).toFixed(2),
        observacao: item.tipo,
        descricao: item.descricao,
        valorAdendo: Number(item.precoPedidoExtra).toFixed(2)
      });     
    });
    itensPreparados.forEach((item) => {
      if (item.id === undefined) {
        this.props.adicionarItem(item);
      } else {
        this.props.editarItem(item, item.id);
      }
    });
    this.props.editarCamposContrato(contrato.data.id, {
      distribuiuItens: 0, 
      pagamentoIndividual: (this.state.orcamento.data.QtFormBoleto > 0 ? "true" : "false"),
      numOrcamento: this.state.orcamento.data.idOrc,
      idClienteMapa: this.state.orcamento.data.codCliente
    });
    await mapavendas.alterarContratoDoOrcamento(this.state.contrato.numero, this.state.orcamento.numero);
    await this.encontrarContrato();
    this.setState({showModalVinculo: false, btnVincular: false}); 
    toast.success("Contrato atualizado com sucesso!");
  }

  async removerItem () {
    let { itemSelecionado } = this.state;
    await this.setState({btnDeletarItem: true});
    await this.props.deletarItem(itemSelecionado.id);
    await this.setState({btnDeletarItem: false, showModalDeletarItem: false, atualizarContrato: true});
    toast.success("Item removido com sucesso!");
  }

  _renderContrato () {
    return (
      <section>
        <div className="row">
          <div className="form-group col-sm-12 col-md-6">
            <label>Contrato</label> 
            <input type="text" className="form-control" value={this.state.contrato.data.numero} readOnly/>
          </div>
          <div className="form-group col-sm-12 col-md-6">
            <label>Designer</label> 
            <input type="text" className="form-control" value={this.state.contrato.data.dono.nome} readOnly/>
          </div>       
        </div>
        <div className="row">
          <div className="form-group col-sm-12">
            <label>Proposta</label> 
            <input type="text" className="form-control" value={this.state.contrato.data.numOrcamento === null ? "Contrato não vinculado a um orçamento" : this.state.contrato.data.numOrcamento} readOnly/>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-12">
            <label>Cliente principal</label>
            <input type="text" className="form-control" value={this.state.contrato.data.usuario.nome ? this.state.contrato.data.usuario.nome : this.state.contrato.data.usuario.email} readOnly/>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-12">
            <label>Curso</label>
            <input type="text" className="form-control" value={this.state.contrato.data.tabela === undefined ? "Não cadastrado" : this.state.contrato.data.tabela.curso} readOnly/>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-12">
            <label>Vendedor</label>
            <input type="text" className="form-control" value={this.state.contrato.data.tabela === undefined ? "Não cadastrado" : this.state.contrato.data.tabela.Nome} readOnly/>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-8">
            <label>Cidade</label>
            <input type="text" className="form-control" value={this.state.contrato.data.tabela === undefined ? "Não cadastrada" : this.state.contrato.data.tabela.Cidade} readOnly/>
          </div>
          <div className="form-group col-sm-4">
            <label>Estado</label>
            <input type="text" className="form-control" value={this.state.contrato.data.tabela === undefined ? "Não cadastrado" : this.state.contrato.data.tabela.SiglaEstado} readOnly/>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-12">
            <label>Instituição</label>
            <input type="text" className="form-control" value={this.state.contrato.data.tabela === undefined ? "Não cadastrada" : this.state.contrato.data.tabela.Instituicao} readOnly/>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-12">
            <label>Itens vinculados ao contrato:</label>
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Item</th>
                    <th>Tipo</th>
                    <th>Qtd</th>
                    <th>Valor</th>
                    <th></th>
                  </tr>
                </thead>
                {
                  this.props.itens.length > 0 ?
                    <tbody>
                      {
                        this.props.itens.map((item, i) => (
                          <tr key={i} title={item.itens !== null ? `Este item da direito a: \n\n${item.itens.replace(/\;/g, "\n")}` : null}>
                            <td>{i + 1}</td>
                            <td>{item.produto}</td>
                            <td>{item.observacao}</td>
                            <td>{item.quantidade}</td>
                            <td>{item.preco === null ? "Não consta" : `R$ ${(item.preco).toFixed(2).toLocaleString()}`}</td>
                            <td><i style={{color: "red", cursor: "pointer"}} className="fa fa-trash" title="Deletar item" onClick={() => {this.setState({itemSelecionado: item, showModalDeletarItem: true})}}></i></td>
                          </tr>
                        ))
                      }
                      <tr>
                        <td colSpan={4} style={{textAlign: "right"}}>TOTAL</td>
                        <td colSpan={2}>{this.state.contrato.preco}</td>
                      </tr>
                    </tbody>
                  : 
                  <tbody>
                    <tr>
                      <td colSpan={6}>Não existem itens vinculados</td>
                    </tr>
                  </tbody>
                }
              </table>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-12">
            <strong>Tipo de pagamento: </strong> {this.state.contrato.data.pagamentoIndividual === "true" ? "pagamento individual" : this.state.contrato.data.pagamentoIndividual === "false" ? "pagamento com a comissão ou parceiro" : "não informado"}
          </div>
        </div>
      </section>
    );
  }

  _renderOrcamento () {
    return (
      <section>
        <div className="row">
          <div className="form-group col-sm-12 col-md-12">
            <label>Contrato</label> 
            <input type="text" className="form-control" value={this.state.orcamento.data.numContrato === null ? "Não informado" : this.state.orcamento.data.numContrato} readOnly/>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-12">
            <label>Proposta</label> 
            <input type="text" className="form-control" value={this.state.orcamento.data.idOrc} readOnly/>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-12">
            <label>Curso</label>
            <input type="text" className="form-control" value={this.state.orcamento.data.curso} readOnly/>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-12">
            <label>Vendedor</label>
            <input type="text" className="form-control" value={this.state.orcamento.data.Nome} readOnly/>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-8">
            <label>Cidade</label>
            <input type="text" className="form-control" value={this.state.orcamento.data.Cidade} readOnly/>
          </div>
          <div className="form-group col-sm-4">
            <label>Estado</label>
            <input type="text" className="form-control" value={this.state.orcamento.data.SiglaEstado} readOnly/>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-12">
            <label>Instituição</label>
            <input type="text" className="form-control" value={this.state.orcamento.data.Instituicao} readOnly/>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-12">
            <label>Itens vinculados ao orçamento:</label>
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Item</th>
                    <th>Tipo</th>
                    <th>Qtd</th>
                    <th>Valor</th>
                  </tr>
                </thead>
                {
                  this.state.orcamento.data.kits.length > 0 ?
                    <tbody>
                      {
                        this.state.orcamento.data.kits.map((item, i) => (
                          <tr key={i} >
                            <td>{i + 1}</td>
                            <td>{item.nome}</td>
                            <td>{item.tipo}</td>
                            <td>{item.qtd}</td>
                            <td>{item.preco === null ? "Não consta" : `R$ ${item.preco.toFixed(2).toLocaleString()}`}</td>
                          </tr>
                        ))
                      }
                      <tr>
                        <td colSpan={4} style={{textAlign: "right"}}>TOTAL</td>
                        <td>{this.state.orcamento.preco}</td>
                      </tr>
                    </tbody>
                  : 
                  <tbody>
                    <tr>
                      <td colSpan={5}>Não existem itens vinculados</td>
                    </tr>
                  </tbody>
                }
              </table>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-12">
            <strong>Tipo de pagamento: </strong> {this.state.orcamento.data.QtFormBoleto > 0 ? "pagamento individual" : "pagamento com a comissão ou parceiro"}
          </div>
        </div>
      </section>
    );
  }

  render() {
    return (
      <div>
        <section>
          <div className="box">
            <div className="box-body" style={{padding:10}}>
              <h3 style={{color: "rgba(0, 0, 0, 0.85)"}}>Vincular Proposta ao Contrato</h3>
              <div className="row">
                <div className="col-sm-12 col-md-6 form-group">
                  <label htmlFor="numContrato">Contrato:</label>
                  <div className="input-group">
                  <input type="text" id="numContrato" className="form-control" value={this.state.contrato.numero} onChange={(e) => { this.setState({ contrato: { ...this.state.contrato, numero: e.target.value } })}} required />
                    <div className="input-group-addon">
                      <button type="button" className="btn btn-default" onClick={this.encontrarContrato.bind(this)}><i className={ this.state.contrato.carregando ? "fa fa-spinner fa-spin" : "fa fa-search"} /></button>
                    </div>
                  </div>
                  <div className="boxItemPesquisado">
                    <div>
                      {
                        this.state.contrato.carregando ?
                          <div style={{display: "flex", justifyContent: "center"}}><i className="fa fa-spinner fa-spin"/></div>
                        : this.state.contrato.data !== undefined ?
                          this._renderContrato()
                        : <div style={{display: "flex", justifyContent: "center"}}>Nenhum contrato selecionado</div>
                      }
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-6 form-group">
                  <label htmlFor="numOrcamento">Orçamento:</label>
                  <div className="input-group">
                  <input type="text" id="numOrcamento" className="form-control" value={this.state.orcamento.numero} onChange={(e) => { this.setState({ orcamento: { ...this.state.orcamento, numero: e.target.value } })}} required />
                    <div className="input-group-addon">
                      <button type="button" className="btn btn-default" onClick={this.encontrarOrcamento.bind(this)}><i className={ this.state.orcamento.carregando ? "fa fa-spinner fa-spin" : "fa fa-search"} /></button>
                    </div>
                  </div>
                  <div className="boxItemPesquisado">
                    <div>
                      {
                        this.state.orcamento.carregando ?
                          <div style={{display: "flex", justifyContent: "center"}}><i className="fa fa-spinner fa-spin"/></div>
                        : this.state.orcamento.data !== undefined ?
                          this._renderOrcamento()
                        : <div style={{display: "flex", justifyContent: "center"}}>Nenhum orcamento selecionado</div>
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <button className="btn btn-danger btn-flat btn-lg pull-right" disabled={(this.state.orcamento.data === undefined || this.state.orcamento.data.kits.length === 0) || this.state.btnVincular} onClick={this.prepararParVincular.bind(this)}>
                    {
                      this.state.btnVincular ? 
                        <span><i className="fa fa-spinner fa-pulse fa-fw"></i> Vinculando</span> 
                      : "Vincular"
                    }
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>  
        <Modal show={this.state.showModalVinculo !== false} onHide={()=>{this.setState({showModalVinculo: false})}} backdrop="static" dialogClassName="modal-50w">
          <Modal.Header closeButton>
            <Modal.Title>Confirmar vínculo</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="alert alert-danger">
              <h3 style={{color: "white"}}>Atenção</h3>
              <p>Os itens abaixo serão adicionados ao contrato (ou suas quantidades serão atualizadas). Faça a conferência antes de finalizar o vínculo!</p>
            </div>
            {
              this.state.novosItens.length > 0 ?
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Item</th>
                        <th>Tipo</th>
                        <th>Qtd</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        this.state.novosItens.map((item, i) => (
                          <tr key={i} >
                            <td>{item.nome}</td>
                            <td>{item.tipo}</td>
                            <td>{item.qtd} <div className="badge">{typeof(item.badge) === "number" && item.badge > 0 ? `+ ${item.badge}` : item.badge}</div></td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </div>
              : "Nenhum item será adicionado / alterado"
            }       
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-flat pull-right" disabled={this.state.btnVincular || this.state.novosItens.length === 0} onClick={this.vincularOrcamentoAoContrato.bind(this)}>{ this.state.btnVincular ? <span><i className="fa fa-spinner fa-spin"></i> Vinculando </span> : "Confirmar" }</button>
            <button className="btn btn-default btn-flat pull-right" style={{marginRight: 10}} disabled={this.state.btnVincular} onClick={() => {this.setState({showModalVinculo: false})}}>Cancelar</button>
          </Modal.Footer>
        </Modal>  
        <Modal show={this.state.showModalDeletarItem !== false} onHide={()=>{this.setState({showModalDeletarItem: false})}} backdrop="static" dialogClassName="modal-30w">
          <Modal.Header closeButton>
            <Modal.Title>Exclusão de itens</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Tem certeza que deseja deletar este item? Essa operação não poderá ser desfeita!</p>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-default btn-flat" onClick={() => {this.setState({showModalDeletarItem: false, itemSelecionado: {}})}}>Cancelar</button>
            <button className="btn btn-danger btn-flat" onClick={this.removerItem.bind(this)} disabled={this.state.btnDeletarItem}>
              {
                this.state.btnDeletarItem ? 
                  <span><i className="fa fa-spinner fa-pulse fa-fw"></i> Deletando</span> 
                : "Deletar"
              }
            </button>
          </Modal.Footer>
        </Modal>  
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    usuario: {autenticado: state.usuario.autenticado, todos: state.usuario.todos},
    contrato: state.contrato.especifico,
    itens: state.item.todos,
    todos: state.contrato.todos,
  };
};

export default connect(mapStateToProps, {
  cadastrarAcao,
  obterContratoPeloNumero,
  obterItensPeloContrato,
  editarCamposContrato,
  adicionarItem,
  editarItem,
  deletarItem,
  enviarEmail,
})(ContratosVincular);



// WEBPACK FOOTER //
// ./src/views/ContratosVincular.js